export default __webpack_public_path__ + "static/media/tranbar.29558bb0.jpg";